/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_HeadingInputs */

const tr_servis_s4_heading = /** @type {(inputs: Servis_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Hizmet Seviyesi Taahhüdü (SLA)`)
};

const en_servis_s4_heading = /** @type {(inputs: Servis_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Service Level Commitment (SLA)`)
};

const de_servis_s4_heading = /** @type {(inputs: Servis_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Zusage zum Service Level (SLA)`)
};

const ru_servis_s4_heading = /** @type {(inputs: Servis_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Обязательство по уровню обслуживания (SLA)`)
};

/**
* | output |
* | --- |
* | "4. Service Level Commitment (SLA)" |
*
* @param {Servis_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_heading = /** @type {((inputs?: Servis_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_heading(inputs)
	if (locale === "de") return de_servis_s4_heading(inputs)
	if (locale === "ru") return ru_servis_s4_heading(inputs)
	return tr_servis_s4_heading(inputs)
});